import { Icon } from "@circle-react-shared/Icon";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon as CompassIcon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";
import { Link, useRouterState } from "@tanstack/react-router";

import { DOCK_NAV_ACTIVE_CLASSES, DOCK_NAV_ROW_CLASSES } from "./constants";
import { isPathActive } from "./isPathActive";
import type { BuildNavItem } from "./types";

interface CircleAIBuildNavRowProps {
  forceActive?: boolean;
  item: BuildNavItem;
}

export const CircleAIBuildNavRow = ({
  forceActive = false,
  item,
}: CircleAIBuildNavRowProps) => {
  const pathname = useRouterState({ select: s => s.location.pathname });
  const isExact = item.exact ?? false;
  const isActive =
    forceActive || isPathActive({ exact: isExact, pathname, to: item.path });
  const icon = isActive && item.activeIcon ? item.activeIcon : item.icon;
  const compassIcon =
    isActive && item.compassActiveIcon
      ? item.compassActiveIcon
      : item.compassIcon;

  return (
    <Link
      to={item.path}
      data-dock-active={isActive || undefined}
      className={classNames(
        DOCK_NAV_ROW_CLASSES,
        isActive && DOCK_NAV_ACTIVE_CLASSES,
      )}
      activeOptions={{ exact: isExact, includeSearch: false }}
    >
      {compassIcon ? (
        <CompassIcon
          name={compassIcon}
          color="primary"
          size="md"
          className="shrink-0"
        />
      ) : (
        <Icon type={icon} size={20} className="shrink-0" />
      )}
      <Typography variant="body-sm" color="primary" truncate>
        {item.label}
      </Typography>
    </Link>
  );
};
